import { render } from "./p-modal.vue?vue&type=template&id=459b47e9"
import script from "./p-modal.vue?vue&type=script&lang=js"
export * from "./p-modal.vue?vue&type=script&lang=js"

import "./p-modal.vue?vue&type=style&index=0&id=459b47e9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__